<script setup lang="ts">
const props = defineProps<{
  name: string,
}>()

const { moves, addOfferMoves } = useBoard(props.name)

const dialog = ref(false)

watch(moves, (value) => {
  const offerMoveMarks = value[value.length - 1]?.offerMoveMarks
  if (!offerMoveMarks || offerMoveMarks.length === 0) {
    if (dialog.value === true) {
      dialog.value = false
    }
    return
  }

  const offerNumberMoves = value.filter(move => move.offerNumber)
  if (offerNumberMoves.length === 0) {
    if (dialog.value === true) {
      dialog.value = false
    }
    return
  }
  const offerNumber = offerNumberMoves[offerNumberMoves.length - 1].offerNumber

  if (offerNumber === offerMoveMarks.length) {
    dialog.value = true
  } else if (dialog.value === true) {
    dialog.value = false
  }
}, { deep: true })

const handleClickOK = () => {
  addOfferMoves()
  dialog.value = false
}
</script>

<template>
  <v-snackbar
    v-model="dialog"
    :attach="`#${props.name}`"
    absolute
    :timeout="-1"
  >
    <span class="text-caption">
      提示しますか
    </span>
    <template #actions>
      <v-btn
        variant="outlined"
        size="small"
        @click="handleClickOK"
      >
        いいえ
      </v-btn>
      <v-btn
        class="ml-2"
        variant="outlined"
        size="small"
        @click="handleClickOK"
      >
        はい
      </v-btn>
    </template>
  </v-snackbar>
</template>
